<div *ngIf="businessUnitResults && businessUnitResults.length > 0">
  <item-combo [ngModel]="selectedBusinessUnit" [items]="businessUnitResults" [presentationMode]="readonly"
              key="id" [ngModelOptions]="{standalone: true}" [nullLabel]="nullLabel" [nullLabelKey]="nullLabelKey" (selectItem)="onChangeItem($event)" [disabled]="disabled">
    <ng-template let-item="item">{{item.name}}</ng-template>
  </item-combo>
</div>
